import { decrypt, encryptAsym } from '@bp/encryption-web'
import axios from 'axios'
import { environment } from '../../environments/environment'
const httpInstance = axios.create()

httpInstance.interceptors.request.use(
  function (config) {
    return {
      ...config,
      data:
        environment.http.encrypt === false
          ? config.data
          : encryptAsym(config.data, {
              cryptoPublicKey: environment.http.publicKey,
            }),
    }
  },
  function (error) {
    return Promise.reject(error)
  }
)

httpInstance.interceptors.response.use(
  function (response) {
    return {
      ...response,
      data:
        environment.http.encrypt === false
          ? response.data
          : decrypt(response.data, {
              cryptoIv: environment.http.ivKey,
              cryptoKey: environment.http.symKey,
            }),
    }
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default httpInstance
